<template>
<!-- 广告管理 -->
<section class="viewContainer">
  <!--工具条-->
  <div v-if="isBanner">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:15px;margin-top:5px">搜索/查询</span>
          <span class="goods_red"/>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" class="findform">
          <el-form-item label="关键词语：" style="display:flex;width:30%">
            <el-input :title="filters.key" v-model="filters.key"  placeholder="Banner标题" style="width:90%"/>
          </el-form-item>
          <el-form-item label="发布位置：" style="display:flex;width:30%" class="select1">
            <el-select v-model="filters.positionId" placeholder="请选择" ref="mySelect" style="width:90%">
              <el-option v-for="(item,index) in positionoptions" :key="index" :value="item.Id" :label="item.Name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="所属城市：" prop="belong" class="optionscity" style="display:flex;width:30%">
            <el-cascader v-model="cityEcho" placeholder="请选择城市" filterable :options="options"
            @change="searchCity" style="width:90%"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section" style="display: flex;justify-content: space-between;">
        <div>
          <p class="model_top_title">广告管理</p>
          <span style="color: #ccc;margin-left: 10px;">鼠标拖动表格所在行更改展示顺序</span>
        </div>
        <div style="margin-right: 10px;">
          <el-button type="danger" @click="showAdd('',1)" v-if="authority.indexOf('add')>-1" data-btnmark="add">新增</el-button>
        </div>
      </section>
      <div class="table_container">
        <el-table :data="tableBanners" stripe border>
          <el-table-column label="序号" align="center">
            <template scope="scope">
              <span>{{scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属城市" align="center">
            <!-- <template scope="scope">
              <span>{{scope.row.PovinceName}} - {{scope.row.CityName}}</span>
            </template> -->
            <template scope="scope">
              <span :title="scope.row.PovinceName+'-'+scope.row.CityName" :label="scope.row.BiddingNo">
                {{scope.row.PovinceName}} - {{scope.row.CityName}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="Title" label="标题" align="center">
            <template scope="scope">
              <span :title="scope.row.Title" :label="scope.row.Title">{{scope.row.Title}}</span>
            </template>
          </el-table-column>
          <el-table-column label="缩略图" align="center">
            <template slot-scope="scoped">
              <div style="height:30px;padding:3px 0px" class="banner_list">
                <img :src="scoped.row.ImgUrl" :data-img="scoped.row.ImgUrl" @click="$imgPreview"
                style="width:100%;height:100%;"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="链接地址" align="center">
            <template scope="scope">
              <span :title="scope.row.LinkUrl" :label="scope.row.LinkUrl">{{scope.row.LinkUrl}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PositionName" label="发布位置" align="center">
            <template scope="scope">
              <span :title="scope.row.PositionName" :label="scope.row.PositionName">{{scope.row.PositionName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="OperatorName" label="操作人" align="center">
            <template scope="scope">
              <span :title="scope.row.OperatorName" :label="scope.row.OperatorName">{{scope.row.OperatorName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="CTime" label="操作时间" align="center">
            <template scope="scope">
              <span :title="scope.row.CTime" :label="scope.row.CTime">{{scope.row.CTime}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="280" align="center">
            <template slot-scope="scoped">
              <span class="handle" @click="showAdd(scoped.row,3)" v-if="authority.indexOf('info')>-1" data-btnmark="info">
                <i class="el-icon-view"></i> 查看
              </span>
              <span class="handle" @click="showAdd(scoped.row,2)" v-if="authority.indexOf('edit')>-1" data-btnmark="edit">
                <i class="el-icon-edit-outline"></i> 编辑
              </span>
              <span class="handle" @click="del(scoped.row)" v-if="authority.indexOf('del')>-1" data-btnmark="del">
                <i class="el-icon-delete"></i> 删除
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next"
        :page-size="10" :total="totalnum" :current-page="filters.pageIndex" style="float:right;margin: 10px 0;"/>
      </div>
    </div>
  </div>
  <!--新增界面 & 编辑页面-->
  <div v-else class="main_container">
    <section style="margin-bottom: 20px;">
      <p class="model_top_title">{{seeshow}}</p>
    </section>
    <el-form :model="form" label-width="110px" ref="editForm">
      <el-row>
        <el-col :span="8">
        <el-form-item label="发布城市：" :rules="[{ required: true}]" style="width:90%">
          <el-cascader v-model="selectedOptions3" placeholder="请选择城市" :options="options1"
          filterable clearable @change="handleChange" :disabled="editFormVisible" style="width:90%"/>
        </el-form-item>
        </el-col>
        <el-col :span="6">
        <el-form-item label="发布平台：" :rules="[{ required: true}]" style="width:90%">
          <el-select v-model="form.SystemId" @change="getItem" :disabled="editFormVisible" style="width:90%">
            <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in kindoptions" :key="index"/>
          </el-select>
        </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="8">
        <el-form-item label="广告标题：" :rules="[{required: true}]" style="width:90%">
          <el-input v-model="form.Title" placeholder="请填写主题" maxlength="50" :disabled="editFormVisible" style="width:90%" show-word-limit />
        </el-form-item>
        </el-col>
        <el-col :span="6">
        <el-form-item label="链接地址：" style="width:90%">
          <el-input v-model="form.LinkUrl" placeholder="请输入链接地址" :disabled="editFormVisible" style="width:90%"/>
        </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
        <el-form-item  label="发布位置：" :rules="[{ required: true}]" style="width:90%;">
          <el-select v-model="form.positionId" :disabled="editFormVisible" style="width:90%">
            <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in addPostions" :key="index"/>
          </el-select>
          <div style="width: 90%;line-height: 26px;margin-top: 10px;">
            <span style="color: #999;" v-show="form.positionId==6">图片尺寸为:宽高1200px“675px，支持JPG、PNG图片格式;单张图片文件不大于5MB。</span>
            <span style="color: #999;" v-show="form.positionId==7">图片尺寸为:宽高1200px“400px，支持JPG、PNG图片格式;单张图片文件不大于5MB。</span>
            <!-- <span style="color: #999;" v-show="form.positionId==6">图片尺寸为:宽高400px*1200px，支持JPG、PNG图片格式;单张图片文件不大于5MB。</span> -->
            <span style="color: #999;" v-show="form.positionId==30">图片尺寸为:宽高1200px“400px，支持JPG、PNG图片格式;单张图片文件不大于5MB。</span>
            <span style="color: #999;" v-show="form.positionId==31">图片尺寸为:宽高1200px“400px，支持JPG、PNG图片格式;单张图片文件不大于5MB。</span>
            <span style="color: #999;" v-show="form.positionId==32">图片尺寸为:宽高550px*550px，支持JPG、PNG图片格式;单张图片文件不大于5MB。</span>
          </div>
        </el-form-item>
        </el-col>
        <el-col :span="6">
        <el-form-item label="图　　片：" :rules="[{ required: true}]" style="width:90%;">
        <el-upload action accept=".png, .jpg,.jpeg" :before-upload="beforeAvatarUpload" :disabled="editFormVisible" class="avatar-uploader activeUploadImg">
          <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" :width="form.SystemId == 2?'135':'345'" height="100%"/>
          <i class="el-icon-plus avatar-uploader-icon" v-else></i>
        </el-upload>
      </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: center; margin-bottom: 20px;">
      <el-button @click="showBan()" v-show="!editFormVisible">取 消</el-button>
      <el-button type="danger" @click="editSubmit()" v-show="!editFormVisible">确定</el-button>
      <el-button @click="backBan()" v-show="editFormVisible">返回</el-button>
    </div>
  </div>
  
  <!-- 删除弹窗 -->
  <el-dialog class="add_bill_delete" width="622px" title="删除" :visible.sync="deleteFormVisble">
    <div class="delete_tips">
      <p>重要信息，你确定要删除吗？</p>
    </div>
    <div class="delete_footer">
      <p @click="deleteFormVisble = false">取消</p>
      <p @click="quedingshan()">确定</p>
    </div>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import NProgress from "nprogress";
import Sortable from "sortablejs"
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, buttongetlist, provincegetcountys } from '../../api/newOss';
import { removeUser, bannerList, getkind, addBanner, delBanner,
 checkBanner, findCity, asideMenu, getUpdateBannerDisplayOrder} from "../../api/api";

function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var dataURL = canvas.toDataURL("image/png"); // 可选其他值 image/jpeg
  return dataURL;
}

function main(src, cb) {
  var image = new Image();
  image.src = src + "?v=" + Math.random(); // 处理缓存
  image.crossOrigin = "*"; // 支持跨域图片
  image.onload = function() {
    var base64 = getBase64Image(image);
    cb && cb(base64);
  };
}
export default {
  mixins: [alertTrends],
  data() {
    var ValidatorEnglish = (rule, value, callback) => {
      if(this.form.SystemId == 1) {
        if (value !== '' && value !== null && value !== undefined) {
          if (!(/(http|https):\/\/([\w.]+\/?)\S*/.test(value))) {
            callback(new Error('请输入正确的url,必须以http,https开头~'))
          }
        }
      }
      callback();
    }
    return {
      showLink: true,
      FileID:"",
      FileUrl:"",
      selectedOptions3: [],
      optionsindex1: 0,
      options1: [],
      show3: true, // 查询区域默认展开
      deleteSure: true,
      optionsindex: 0,
      options: [],
      leibiao: [],
      shengarr: "",
      provinceoptions: "",
      provinceoptionsId: 0,
      shengId: 0,
      shengarr1: "",
      provinceoptions1: "",
      provinceoptionsId1: 0,
      shengId1: 0,
      deleteFormVisble: false,
      delid: "",
      kindoptions: "",
      positionoptions: [], // 搜索区域 发布位置
      addPostions: [], // 发布位置
      filters: {
        key: "",
        positionId: "",
        pageIndex: 1,
        pageSize: 10
      },
      tableBanners: [],
      rules:{
        LinkUrl:[ { validator: ValidatorEnglish, trigger: 'change' } ]
      },
      page: 1,
      form: {
        Title: "",
        ImgUrl: "",
        LinkUrl: "",
        SystemId: "",
        positionId: "",
        OperatorId: "",
       belong:"",
      },
      editForm:{
      belong:"",
      },
      totalnum: 0, // 总页数
      checkId: "",
      cityEcho: [], // 列表页所属城市默认填充第一条数据
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isBanner: true,
      editFormVisible: false, // 编辑界面显是否显示
      seeshow: '广告管理新增', // 详情页title

      authority: '', // 按钮权限
      
    };
  },
  components: {
    Sortable
  },
  methods: {
    // 初始化查询列表
    init() {
      var loginParams = {
        key: this.filters.key,
        positionId: this.filters.positionId,
        pageIndex: this.filters.pageIndex,
        pageSize: this.filters.pageSize,
        povinceId: this.shengId,
        cityId: this.provinceoptionsId,
        userId: localStorage.Id
      };
      bannerList(loginParams).then(data => {
        if(data.ResultCode == 1) {
          this.tableBanners = data.ResultObj;
          this.totalnum = data.RowsCount;
          // localStorage.setItem("token", res.token);
        } else {
          this.tableBanners = [];
        }
      })
    },
    // 新增 编辑 查看
    showAdd(row,type) {
      let that = this;
      this.isBanner = false;
      this.publishingPlatform(); // 发布平台
      this.getprovince();
      if(type == 1){
        this.seeshow = '广告管理新增';
        this.editFormVisible = false;
        this.checkId = 0;
        this.shengId1 = 0; // 省
        this.provinceoptionsId1 = 0; // 市
        this.selectedOptions3 = [];
        this.form.Title = "";
        this.form.ImgUrl = "";
        this.form.LinkUrl = "";
        this.form.positionId = 0;
        this.form.SystemId = '';
        // if(this.form.SystemId == 1) {
        //   this.showLink = true;
        // } else {
        //   this.showLink = false;
        // }
      }
      if(type == 2){
        this.seeshow = '广告管理修改';
        this.editFormVisible = false;
        this.checkId = row.Id;
        this.shengId1 = row.PovinceId;
        this.provinceoptionsId1 = row.CityId;
        this.selectedOptions3 = [row.PovinceId, row.CityId]
        this.form.Title = row.Title;
        this.form.ImgUrl = row.ImgUrl;
        this.FileUrl = row.ImgUrl.replace(localStorage.BaseOssUrl, '')
        
        this.form.LinkUrl = row.LinkUrl;
        this.form.SystemId = row.SystemId;
        // if(this.form.SystemId == 2) {
        //   this.showLink = false;
        // } else {
        //   this.showLink = true;
        // }
        this.form.positionId = row.PositionId;
        this.form.OperatorId = this.$cookie.get("OperatorId");
        main(row.ImgUrl, function(base64) {
          that.form.ImgUrl = base64;
        });
      }
      if(type == 3){
        this.seeshow = '查看';
        this.editFormVisible = true;
        this.checkId = row.Id;
        this.shengId1 = row.PovinceId;
        this.provinceoptionsId1 = row.CityId;
        this.selectedOptions3 = [row.PovinceId,row.CityId]
        this.form.Title = row.Title;
        // this.form.ImgUrl = row.ImgUrl;
        this.form.LinkUrl = row.LinkUrl;
        this.form.SystemId = row.SystemId;
        // if(this.form.SystemId == 2) {
        //   this.showLink = false;
        // } else {
        //   this.showLink = true;
        // }
        this.form.positionId = row.PositionId;
        this.form.OperatorId = this.$cookie.get("OperatorId");
        main(row.ImgUrl, function(base64) {
          that.form.ImgUrl = base64;
        });
      }
    },
    // 编辑 or 新增
    editSubmit() {
      if(this.selectedOptions3 == ''){
        this.showAlert('请选择发布城市');
        return false
      }
      if(this.form.Title == ""){
        this.showAlert('请输入广告标题');
        return false
      }
      if(this.form.positionId == 0){
        this.showAlert('请选择发布位置');
        return false
      }
      if(this.form.ImgUrl == ""){
        this.showAlert('请上传图片');
        return false
      }
      let loginParams = {
        id: this.checkId,
        Title: this.form.Title,
        ImgUrl:  this.FileUrl,
        SystemId: this.form.SystemId,
        PositionId: this.form.positionId,
        OperatorId: this.form.OperatorId,
        // LinkUrl: this.form.LinkUrl,
        // LinkUrl: this.form.LinkUrl = this.form.SystemId == 2 ? "" : this.form.LinkUrl,
        LinkUrl: this.form.LinkUrl,
        // LinkUrl: this.form.SystemId == 2 ? "" : this.form.LinkUrl,
        PovinceId: this.shengId1,
        CityId: this.provinceoptionsId1
      };
      let thisApi = this.checkId?checkBanner:addBanner;
      thisApi(loginParams).then(data => {
        if (data.ResultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.isBanner = true;
          this.filters.pageIndex = 1;
          this.init();
        }
      });
    },
    // 拖拽
    drag() {
      const el = document.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      Sortable.create(el, {
        disabled: false, // 拖拽不可用? false 启用
        ghostClass: 'sortable-ghost', //拖拽样式
        animation: 150, // 拖拽延时，效果更好看
        onEnd: (e) => { // 拖拽结束时的触发
            let arr = this.tableBanners; // 获取表数据
            arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
            this.$nextTick(function () {
              this.tableBanners= arr;
              this.myend();
            })
        },
      });
    },
    // 调取拖拽方法的接口
    myend() {
      let addParams = {
        bannerIds: this.tableBanners.map(item=>item.Id).join(","), // 页面banner列表的id，多个以英文逗号分隔，参数示例：13515,13511,13521,13517,13513
      };
      getUpdateBannerDisplayOrder(addParams).then(r => {
        if (r.ResultCode == 1) {
          this.init(); // 调用查询列表接口
        }
        if(r.ResultCode == 0) {
          this.showAlert(data.ResultMsg, 'error');
        }
        if(r.ResultCode == 2) {
          this.showAlert(data.ResultMsg, 'error');
        }
      });
    },
    // 查询列表所属城市
    searchCity(val) {
      this.shengId = val[0];
      this.provinceoptionsId = val[1];
    },
    // 详情页所属城市
    handleChange(val) {
      this.shengId1 = val[0];
      this.provinceoptionsId1 = val[1];
    },
    // 列表页查找省
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        provinceAndCityAndarea.unshift({ value: 0, label: '全国',});
        that.options = provinceAndCityAndarea;
        that.options1 = provinceAndCityAndarea;
      })
    },
    // 验证图片尺寸
    // allowSize(sizeList) {
    //   var sizeList_str = sizeList.map(wh => wh[0] + '|' + wh[1])
    //   return (w,h) => sizeList_str.find(size => w + '|' + h == size) ? true : false
    // },
    allowSize(sizeList, range) {
      if(range){  // sizeList = [[123,123],[234,999]]
        var sizeRange_w = sizeList[0]
        var sizeRange_h = sizeList[1]
        return (w,h) => {
          if(w >= sizeRange_w[0] && w<= sizeRange_w[1] && h >= sizeRange_h[0] && h<= sizeRange_h[1]){
            return true
          }else{
            return false
          }
        }
      }else{
        var sizeList_str = sizeList.map(wh => wh[0] + '|' + wh[1])
        return (w,h) => sizeList_str.find(size => w + '|' + h == size) ? true : false
      }
    },
    // 图片上传前判断格式大小
    beforeAvatarUpload(file) {
      if(!this.form.SystemId) {
        this.showAlert('请选择发布平台');
        return
      }
      if (this.form.SystemId == 1 && this.form.positionId != 20) {
        const isSize = new Promise(function(resolve, reject) {
          let width = 1920;
          let height = 450;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then( () => {
          var _this = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function(e) {
            /* oss 直传图片 */
            var obj = {type: 0};
            getOssFile(obj).then(data => {
              if (data.resultCode == 1) {
                let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
                let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
                let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
                let ossfile = data.resultObj.directory; // 保存路径
                let ossbucket = data.resultObj.bucket; // bucket
                localStorage.setItem('keyossId',ossId);
                localStorage.setItem('keyossSecret',ossSecret);
                localStorage.setItem('keyossHost',ossHost);
                localStorage.setItem('keyossfile',ossfile);
                localStorage.setItem('keyossbucket',ossbucket);
              }
            })
            var newOssPic = await uploadOSS(file,0);
            _this.form.ImgUrl = newOssPic;
            _this.FileUrl = newOssPic.replace(localStorage.BaseOssUrl,'')

          };
          return file;
        },
        () => {
          this.showAlert('上传的图片尺寸必须是等于1920*450!');
          return Promise.reject();
        });
        return isSize;
      } else if (this.form.SystemId == 2) {
        const isSize = new Promise((resolve, reject) => {
          if(this.form.positionId == 6) {
            var verifySize = this.allowSize([[1200,675]])
          }
          if(this.form.positionId == 7) {
            var verifySize = this.allowSize([[1200,400]])
          }
          if(this.form.positionId == 30) {
            var verifySize = this.allowSize([[1200,400]])
          }
          if(this.form.positionId == 31) {
            var verifySize = this.allowSize([[1200,400]])
          }
          if(this.form.positionId == 32) {
            var verifySize = this.allowSize([[550,550],[236,9999]],true)
          }
          // let width = newWidth;
          // let height = newHeight;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            // let valid = img.width == width && img.height == height;
            let valid = verifySize(img.width,img.height);
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then( () => {
            var _this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async function(e) {
              _this.form.ImgUrl = e.target.result;
              /* oss 直传图片 */
              var obj = {type: 0};
              getOssFile(obj).then(data => {
                if (data.resultCode == 1) {
                  let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
                  let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
                  let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
                  let ossfile = data.resultObj.directory; // 保存路径
                  let ossbucket = data.resultObj.bucket; // bucket
                  localStorage.setItem('keyossId',ossId);
                  localStorage.setItem('keyossSecret',ossSecret);
                  localStorage.setItem('keyossHost',ossHost);
                  localStorage.setItem('keyossfile',ossfile);
                  localStorage.setItem('keyossbucket',ossbucket);
                }
              })
              var newOssPic = await uploadOSS(file,0);
              _this.form.ImgUrl = newOssPic;
              _this.FileUrl = newOssPic.replace(localStorage.BaseOssUrl,'')

            };
            return file;
          },
          () => {
            if(this.form.positionId == 6) {
              this.showAlert('上传的图片尺寸必须是等于1200*675');
            }
            if(this.form.positionId == 7) {
              this.showAlert('上传的图片尺寸必须是等于1200*400');
            }
            if(this.form.positionId == 30) {
              this.showAlert('上传的图片尺寸必须是等于1200*400');
            }
            if(this.form.positionId == 31) {
              this.showAlert('上传的图片尺寸必须是等于1200*400');
            }
            if(this.form.positionId == 32){
              this.showAlert('上传的图片尺寸必须是等于550*550');
            }
            return Promise.reject();
          });
        return isSize;
      } else if (this.form.SystemId == 1 && this.form.positionId == 20) {
        const isSize = new Promise(function(resolve, reject) {
          let width = 580;
          let height = 290;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then( () => {
          var _this = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function(e) {
            _this.form.ImgUrl = e.target.result;
          };
          return file;
        },
        () => {
          this.$message.error("上传的图片尺寸必须是等于580*290!");
          return Promise.reject();
        });
        return isSize;
      }
    },
    // 切换发布平台 并清空发布位置
    getItem(value) {
      // if(value == 2) {
      //   this.showLink = false;
      // } else {
      //   this.showLink = true;
      // }
      if(this.form.SystemId == 1 || this.form.SystemId == 2) {
        this.form.LinkUrl = "";
      }
      this.form.positionId = "";
      this.addPosition();
      this.form.ImgUrl = ""
    },
    // 获取发布平台 请选择里的东西
    publishingPlatform() {
      let that = this;
      var loginParams = {
        tableName: "tbdsystemtype",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        that.kindoptions = data.ResultObj;
        that.form.SystemId = data.ResultObj[0].Id;
        that.addPosition();
      })
    },
    // 新增发布位置级联
    addPosition() {
      let that = this;
      var loginParams = {
        tableName: "tbdbannerposition",
        keyWord: "",
        parentId: that.form.SystemId
      };
      getkind(loginParams).then(data => {
        let newdata = data.ResultObj;
        newdata.unshift({ Id: 0, Name: '请选择',});
        that.addPostions = newdata;
        if(newdata) {
          that.form.positionId == "" ? (that.form.positionId = newdata[0].Id) : "";
        }
      })
    },
    // 搜索区域 获取发布位置
    getposition() {
      let that = this;
      var loginParams = {
        tableName: "tbdbannerposition",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        let newdata = data.ResultObj;
        this.positionoptions = newdata;
        this.filters.positionId = newdata[0].Id;
        this.init();
      })
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    // 查询
    onSubmit() {
      this.filters.pageIndex = 1;
      this.init();
    },
    // 删除
    del(scope) {
      this.delid = scope.Id;
      this.deleteSure = true;
      this.$swal({
        type:'warning',
        text: '重要信息，你确定要删除吗？',
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then((res) => {
      if(res.value){
        this.quedingshan()
      }
      })
    },
    quedingshan() {
      if (this.deleteSure) {
        this.deleteSure = false;
        this.deleteFormVisble = false;
        let t = this;
        var loginParams = {
          id: t.delid
        };
        delBanner(loginParams).then(data => {
            if (data.ResultCode == 1) {
              this.showAlert('删除成功', 'success');
              t.init();
            }
          }).catch(err => {
            t.deleteFormVisble = false;
          });
      }
    },
    
    showBan() {
      this.isBanner = true;
    },
    handleCurrentChange(val) {
      let that = this;
      that.filters.pageIndex = val;
      that.init();
    },
    // 删除
    handleDel: function(row) {
      var _this = this;
      this.$confirm("确认删除该记录吗?", "提示", {}).then(() => {
        NProgress.start();
        let para = {
          id: row.id
        };
        removeUser(para).then(res => {
          NProgress.done();
          _this.getUsers();
        });
      });
    },
    //获取上传图片的路径
    // handleAvatarSuccess(res, file) {
    //     var _this = this;
    //     var reader = new FileReader();
    //     reader.readAsDataURL(file[file.length - 1].raw);
    //     reader.onload = function (e) {
    //         _this.form.ImgUrl = e.target.result;
    //     };
    // },
    backBan() {
      this.isBanner = true;
    },
    //列表权限
    getFuncNode() {
      let params = {
        type: 1,
        userId: this.$cookie.get("OperatorId") || 2,
        parentId: 0
      };
      asideMenu(params).then(r => {
        let actionId = [],
        actions = r.ResultObj;
        actions.forEach(element => {
          actionId.push(element.id);
        });
        this.$cookie.set("actionId", actionId);
        this.leibiao = actionId;
        // if (this.leibiao.indexOf(2) > -1) {
        //   this.isBanner = true;
        // } else {
        //   this.isBanner = false;
        // }
      });
    },
    // 按钮权限
    handlebtn(){
      let obj = {mark: 'banner',};
      buttongetlist(obj).then(data => {
        this.authority = data.resultObj;
      })
    },
  },
  created() {
    this.getposition();
    this.form.OperatorId = this.$cookie.get("OperatorId");
    this.$nextTick(() => {
      this.drag();
    });
    this.getprovince();
    this.getFuncNode();
    this.handlebtn(); // 按钮权限
  },
};
</script>
<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor:pointer
}

/* 内容表格 */
.banner_table {
  width: 99.5%;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}

/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}

/* .banner_table .el-col-22 p {
  width: 80px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
.banner_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
} */
/* 表格 */
.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}

/* 表格操作 */
.ban_tab p {
  float: left;
  color: #677c9d;
  width: 30%;
}

/* .ban_tab p img{
  margin-top:10px
} */
.ban_tab p:first-child {
  margin-left: 10%;
}
</style>


// WEBPACK FOOTER //
// banner.vue?2a016ef8